import React from 'react';
import p11 from '../../img/projects/one/p31.JPG'
import p12 from '../../img/projects/one/p32.JPG'
import p13 from '../../img/projects/one/p33.JPG'
import Tittle from '../Tittle';

const ProjectsThree = () => {
    const three = {
        id: 3,
        live: 'Live Site',
        git: 'GitHub(Client)',
        title: 'Haydar Medical Center',
        link: 'https://affectionate-panini-29c3f2.netlify.app/',
        linkgc: 'https://github.com/alihaydararman/healthcare-related-website',
        date: '15',
        month: 'Jun',
        year: '2018',
        details: 'Details',
        projects: '/projects3'
    }
    return (
        <div className="container">
            <div classNameName="b-title">
                <Tittle title={three.title} span={three.title} />
            </div>
            <div className='py-5'>
                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={p11} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p12} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p13} className="d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div>
                <div className='row-12'>

                    <p>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={three.link}>{three.live}</a></button>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={three.linkgc}>{three.git}</a></button>
                    </p>
                    <h1>Project Name :{three.title}</h1>
                </div>
                <div className='row-12'>
                    <ul>
                        <li>It is a Health Care Related responsive website from where someone can book appointment in doctor for any specific department’s doctor.</li>
                        <li>As booking appointment is private route so anyone cannot book appointment without login or sign up or sign in using Google (any one).</li>
                        <li>After login and provide patient’s information users will get an appointment id and confirm page for confirmation.</li>
                    </ul>
                    <p><strong>Front-end Technology: </strong>HTML5, CSS3, Bootstrap5, React.js, React-Router, JSX, Firebase. </p>
                </div>
            </div>
        </div>
    );
};

export default ProjectsThree;